/**
 * 快速发起icon
 */
import Ajax from "Pub/js/ajax";
import Notice from "Components/Notice";
import { langCheck, throttle } from "Pub/js/utils";
import platform from "Pub/js/platform";
const { base } = platform;
const { NCTooltip } = base;

//快速新增
export function QuickAddIcon(props) {
    const { appData, visible, icon = 'icon-kuaisuxinzeng', containerClassName, openParams = {} } = props;

    const handleClick = throttle(e => {
        e.stopPropagation();
        getBtnAuth(appData).then(() => {
            if (appData) {
                const newAppData = JSON.parse(JSON.stringify(appData));
                if (newAppData.code) {
                    newAppData.menuitemcode = newAppData.code; //传菜单编码
                }
                window.openNew(newAppData, null, null, {
                    targetPagecode: newAppData.fastlaunchpagecode,
                    funcParams: {
                        isQuickAdd: true,
                        unique: true
                    },
                    ...openParams
                });
            }
        });
    });

    //获取新增按钮的权限
    const getBtnAuth = params => {
        return new Promise(resolve => {
            Ajax({
                url: `/nccloud/platform/appregister/fastlaunch.do`,
                data: {
                    appcode: params.appcode,
                    fastlaunchparam: params.fastlaunchparam,
                },
                success: ({ data: { data } }) => {
                    if (data) {
                        if (data.is_fastlaunch) {
                            resolve();
                        } else {
                            Notice({
                                status: "warning",
                                msg: data.hint_message,
                            });
                        }
                    }
                },
            });
        });
    };
    const renderIcon = () => (
        <NCTooltip
            className="app-tooltip"
            placement="top"
            overlay={langCheck("0000PUB-000414")} /** 快速新增 */
            trigger="hover"
            delayShow={500}
            delay={1}
            getPopupContainer={() => document.body}
        >
            <i className={`iconfont ${icon} icon-apply`} onClick={handleClick} />
        </NCTooltip>
    );
    if (!visible) {return null;}
    return containerClassName ? (
        <div className={containerClassName} onClick={handleClick}>
            {renderIcon()}
        </div>
    ) : (
        renderIcon()
    );
}
